export enum RequestStatus {
  SAVED = 'SAVED',
  PENDING = 'PENDING',
  VALIDATED = 'VALIDATED',
  ON_GOING = 'ON_GOING',
  CANCELLED_BY_CLIENT = 'CANCELLED_BY_CLIENT',
  CANCELLED_BY_MANAGER = 'CANCELLED_BY_MANAGER',
}
